import {
    useState,
} from 'react';

type Props = {
    testimonial?: any;
    onClose: () => void;
    onSave: (
        data: any
    ) => void;
};

export default function TestimonialModal({

                                             testimonial,

                                             onClose,

                                             onSave,

                                         }: Props)
{
    const [
        name,
        setName
    ] = useState(
        testimonial?.name || ''
    );

    const [
        place,
        setPlace
    ] = useState(
        testimonial?.place || ''
    );

    const [
        rating,
        setRating
    ] = useState(
        testimonial?.rating ?? 5
    );

    const [
        comment,
        setComment
    ] = useState(
        testimonial?.comment || ''
    );

    const [
        isActive,
        setIsActive
    ] = useState(
        testimonial?.is_active ?? true
    );

    const handleSubmit = (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        onSave({

            name,

            place,

            rating,

            comment,

            is_active:
            isActive,

        });

    };

    return (

        <div
            className="modal-overlay"
            onClick={onClose}
        >

            <div
                className="modal-box"
                onClick={(e) =>
                    e.stopPropagation()
                }
            >

                <h2>

                    {

                        testimonial

                            ?

                            'Edit Testimonial'

                            :

                            'Add Testimonial'

                    }

                </h2>

                <form
                    className="modal-form"
                    onSubmit={
                        handleSubmit
                    }
                >

                    <label>
                        Name
                    </label>

                    <input
                        type="text"
                        value={name}
                        onChange={(e) =>
                            setName(
                                e.target.value
                            )
                        }
                        required
                    />

                    <label>
                        Place
                    </label>

                    <input
                        type="text"
                        value={place}
                        onChange={(e) =>
                            setPlace(
                                e.target.value
                            )
                        }
                        required
                    />

                    <label>
                        Rating
                    </label>

                    <select
                        value={rating}
                        onChange={(e) =>
                            setRating(
                                Number(
                                    e.target.value
                                )
                            )
                        }
                    >

                        <option value={1}>
                            1 Star
                        </option>

                        <option value={2}>
                            2 Stars
                        </option>

                        <option value={3}>
                            3 Stars
                        </option>

                        <option value={4}>
                            4 Stars
                        </option>

                        <option value={5}>
                            5 Stars
                        </option>

                    </select>

                    <label>
                        Comment
                    </label>

                    <textarea
                        rows={6}
                        value={comment}
                        onChange={(e) =>
                            setComment(
                                e.target.value
                            )
                        }
                        required
                    />

                    <label>
                        Active
                    </label>

                    <select
                        value={
                            isActive
                                ? '1'
                                : '0'
                        }
                        onChange={(e) =>
                            setIsActive(
                                e.target.value ===
                                '1'
                            )
                        }
                    >

                        <option value="1">
                            Yes
                        </option>

                        <option value="0">
                            No
                        </option>

                    </select>

                    <div className="modal-actions">

                        <div className="left-actions">

                            <button
                                type="button"
                                className="cancel-btn"
                                onClick={
                                    onClose
                                }
                            >
                                Cancel
                            </button>

                        </div>

                        <div className="right-actions">

                            <button
                                type="submit"
                                className="action-btn"
                            >
                                Save
                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </div>

    );
}
